import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import AcertosPorHabilidade from "../../../../components/Statistics/AcertosPorHabilidade";
import AcertosPorObjetivo from "../../../../components/Statistics/AcertosPorObjetivo";
import AcertosPorQuestao from "../../../../components/Statistics/AcertosPorQuestao";
import AcertosPorUnidadeTematica from "../../../../components/Statistics/AcertosPorUnidadeTematica";
import DataQ from "../../../../components/Statistics/DataQuestions/index";
import Chart1 from "../../../../components/Statistics/HistogramaDaTurma/index";
import ListaNotas from "../../../../components/Statistics/ListaNotas";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./style.css";

class EvaluationStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      // loading: true,
      applications: [],
      menu: "Histograma das Notas"
    };
  }

  async componentDidMount() {
    const respApplications = await axios.get(
      `${URL.api}evaluation/application/report?allocation_id=${this.props.allocation_id}`,
      { headers: { Authorization: `Bearer ${this.props.user.token}` } }
    );
    const respList = await axios.get(
      `${URL.api}evaluation/question/lists/singleViewWithOptions/${respApplications.data.data[0]?.list_id}`,
      { headers: { Authorization: `Bearer ${this.props.user.token}` } }
    );

    this.setState({
      applications: respApplications.data.data,
      list: respList.data.data
    });
  }

  getMenus() {
    return [
      {
        name: "Histograma das Notas",
        component: <Chart1 applications={this.state.applications} />
      },
      {
        name: "Lista de Notas",
        component: <ListaNotas applications={this.state.applications} />
      },
      {
        name: "Avaliação - Descritor e Distrator",
        component: (
          <DataQ
            applications={this.state.applications}
            list={this.state.list}
          />
        )
      },
      {
        name: "Acertos por questão",
        component: (
          <AcertosPorQuestao
            applications={this.state.applications}
            list={this.state.list}
          />
        )
      },
      {
        name: "Acertos por assunto",
        component: (
          <AcertosPorHabilidade
            applications={this.state.applications}
            list={this.state.list}
          />
        )
      },
      {
        name: "Acertos por Objetivo",
        component: (
          <AcertosPorObjetivo
            applications={this.state.applications}
            list={this.state.list}
          />
        )
      },
      {
        name: "Acertos por Unidade Temática",
        component: (
          <AcertosPorUnidadeTematica
            applications={this.state.applications}
            list={this.state.list}
          />
        )
      }
    ];
  }

  render() {
    return (
      <>
        {this.getMenus().find(menu => menu.name === this.state.menu).component}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationStatistics);
